import { V2UserResourceWrite } from "@generated";
import { User } from "../types";
import { preferenceRelationship } from "@components/PreferredDefaultsFields";

export const formatUser = (
  user: User,
  accountId?: string
): V2UserResourceWrite => {
  let data: V2UserResourceWrite = {
    type: "users",
    attributes: {
      name: user.name || "",
      title: user.title || undefined,
      email: user?.email || "",
      phone: user?.phone || undefined,
      sales: user?.sales || false,
      presales: user?.presales || false,
      "sso-provider": user?.ssoProvider,
      "user-type": user.userType as
        | "view_only"
        | "licensed"
        | "sales"
        | "service"
        | undefined,
      "start-page": user.startPage as
        | "Home"
        | "Projects"
        | "Approvals"
        | "Surveys"
        | "Settings",
    },
    relationships: {
      teams: {
        data:
          user?.teams?.map((t) => {
            return { id: String(t.value), type: "teams" };
          }) || [],
      },
      roles: {
        data:
          user?.roles?.map((r) => {
            return { id: String(r.value), type: "roles" };
          }) || [],
      },
      account: accountId
        ? { data: { id: String(accountId), type: "accounts" } }
        : undefined,
      // Only once loaded: sending null would reset the user to the default.
      ...(user.rateTableId !== undefined
        ? { "rate-table": preferenceRelationship(user.rateTableId, "rate-tables") }
        : {}),
      ...(user.currencyId !== undefined
        ? { currency: preferenceRelationship(user.currencyId, "currencies") }
        : {}),
    },
  };

  if (user.id !== 0) {
    data.id = String(user.id);
  }
  return data;
};
